import { ApiUserData, RequestInfoPayload } from "../../../api-http/types";
import { RequestInfoFormTypes } from "./types";

export const mapFormDataToApiPayload = (
  formData: RequestInfoFormTypes,
  recaptchaToken: string,
  currentUrl: string
): RequestInfoPayload => ({
  city: formData.city ?? "",
  company: formData.company,
  consents: Object.keys(formData.consents).map((key) => ({
    status: formData.consents[key] ? "active" : "inactive",
    consentId: key,
  })),
  country: {
    id: formData.country,
  },
  email: formData.email,
  firstName: formData.firstName,
  lastName: formData.lastName,
  materials: formData.materials?.map((material) => ({ id: material })),
  phone: formData.phone,
  province: {
    id: formData.stateId ?? undefined,
    value: formData.state ?? undefined,
  },
  zipCode: formData.zipCode,
  gRecaptchaResponse: recaptchaToken,
  machineSerialNumber: formData.machineSerialNumber,
  message: formData.message,
  processOfInterest: formData.processOfInterest?.map((element) => ({ id: element })),
  sourceURL: currentUrl,
});

export const mapApiPayloadToFormData = (apiPayload: ApiUserData): RequestInfoFormTypes => {
  let consents: Record<string, boolean | null> = {};
  apiPayload.consents.forEach((consent) => {
    consents[consent.consentId] = consent.status === "active";
  });
  return {
    company: apiPayload.company,
    country: apiPayload.country?.id ?? "",
    email: apiPayload.email,
    firstName: apiPayload.firstName,
    lastName: apiPayload.lastName,
    phone: apiPayload.phone,
    stateId: apiPayload.province?.id ?? null,
    state: apiPayload.province?.value ?? null,
    zipCode: apiPayload.zipCode,
    consents: consents,
    materials:
      (apiPayload.materials
        ?.map((material) => material.id)
        ?.filter((x) => x !== undefined) as string[]) ?? [],
    message: "",
    subject: "",
    city: apiPayload.city ?? null,
    machineSerialNumber: "",
    processOfInterest: [],
  };
};
